<template>
  <div class="content">
    
    <div class="container-fluid background_color"><br>
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card class="bdr-rad2 shadow ">
            <div slot="header" class="icon-warning">
              <img class="mb-3" src="/img/chart1.jpg" alt="" width="50px">
            </div>
            <div slot="content">
              <p class="card-category">Total Revenue</p>
              <h4 class="card-title">{{all_data.total_amount}}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-calendar-o"></i>This Month
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card class="bdr-rad2 shadow ">
            <div slot="header" class="icon-success">
              <img class="mb-3" src="/img/funding.png" alt="" width="50px">
            </div>
            <div slot="content">
              <p class="card-category"> Total Debtors</p>
              <h4 class="card-title">{{all_data.dtotal_val}}</h4>
            </div>
            <div slot="footer">
              <!-- <i class="fa fa-calendar-o"></i>Last day -->
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card class="bdr-rad2 shadow ">
            <div slot="header" class="icon-danger">
             
           
              <img class="mb-3" src="/img/pending.png" alt="" width="50px">
              <!-- <h4 class="card-title">{{all_data.count_qut}}</h4> -->
            </div>
            <div slot="content">
              <p class="card-category">Pending Quotations</p>
              <h4 class="card-title">{{all_data.total_qut}}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-calendar-o"></i>This Month
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card class="bdr-rad2 shadow " style="padding-bottom: 7px;">
            <div slot="header" class="icon-info">
              <p style="font-size: medium;" class=""><b>Top 5 Dealers</b></p>
            </div>
            <div slot="content">

             
          
             
                <table style="float: right; width: auto;">
                <tr >
                  <td style="padding-left: 10px;"><p  class="card-category">Last Year</p></td>
                  <td style="padding-left: 20px;"><p  class="card-category">This Year</p></td>
                </tr>
                <tr>
                  <td> <p style="font-size: 11px;" v-for="(name, index) in dealer_names_last" :key="index" class="card-category">{{ name }}</p></td>
                  <td> <p style="font-size: 11px;" v-for="(name1, index) in dealer_names1_this" :key="index" class="card-category">{{ name1 }}</p></td>
                </tr>
              </table>

           
               
            
              
             
             
             
            </div>
            
          </stats-card>
        </div>

      </div>

      <div class="row">
        <div class="col-md-6" >
          <chart-card class="bdr-rad2 shadow  p-1" v-if="isLoaded"
            :chart-data="lineChart.data"
            :chart-options="lineChart.options"
            :chart-responsive-options="lineChart.responsiveOptions"
            chart-type="Line">
            <template slot="header">
              <h4 class="card-title">Monthly Sales Summary</h4>
              <p class="card-category"></p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Sales
                <!-- <i class="fa fa-circle text-danger"></i> BMW 5 Series -->
              </div>
              <!-- <hr> -->
              <!-- <div class="stats">
                <i class="fa fa-check"></i> Data information certified
              </div> -->
            </template>
          </chart-card>
        </div>

        <div class="col-md-6" >
          <chart-card class="bdr-rad2 shadow  p-1" v-if="isLoaded"
            :chart-data="lineChart1.data"
            :chart-options="lineChart1.options"
            :chart-responsive-options="lineChart1.responsiveOptions"
            chart-type="Line">
            <template slot="header">
              <h4 class="card-title">Weekly Sales Summary</h4>
              <p class="card-category"></p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Sales
                <!-- <i class="fa fa-circle text-danger"></i> BMW 5 Series -->
              </div>
              <!-- <hr> -->
              <!-- <div class="stats">
                <i class="fa fa-check"></i> Data information certified
              </div> -->
            </template>
          </chart-card>
        </div>




      

      
      </div>



<div class="row">
  <div class="col-md-4">

<div id="app">
  <chart-card class="bdr-rad2 shadow  p-1" v-if="isLoaded5" 
    :chart-data="barChart4.data"
    :chart-options="barChart4.options"
    :chart-responsive-options="barChart4.responsiveOptions"
    chart-type="Bar"
  >
    <template slot="header">
      <h4 class="card-title">Sales by Dealer</h4>
      <p class="card-category"></p>
    </template>
    <template slot="footer">
      <div class="legend">
        <i class="fa fa-circle text-info"></i> Sales
      </div>
    </template>
  </chart-card>
</div>

</div>

<div class="col-md-4">

<div id="app">
  <chart-card class="bdr-rad2 shadow  p-1"  v-if="isLoaded4"
    :chart-data="barChart3.data"
    :chart-options="barChart3.options"
    :chart-responsive-options="barChart3.responsiveOptions"
    chart-type="Bar"
  >
    <template slot="header">
      <h4 class="card-title">Sales by Salesman</h4>
      <p class="card-category"></p>
    </template>
    <template slot="footer">
      <div class="legend">
        <i class="fa fa-circle text-info"></i> Sales
      </div>
    </template>
  </chart-card>
</div>

</div>

<div class="col-md-4">
          <div id="app">
    <DonutChartcon class="bdr-rad2 shadow  p-1" v-if="isLoaded9"
      :data="chartData1"
      :colors="chartColors"
     
      :completionRate="valuequtation"
    
    >
      <template v-slot:header>
        <h4 class="card-title">Quotations this Month</h4>
      
      </template>
      <template v-slot:footer>
        <div class="legend">
          <i class="fa fa-circle text-info"></i> Quoatations
        </div>
      </template>
    </DonutChartcon>
  </div>
</div>






</div>

<div class="row">
  <div class="col-md-4">
          <chart-card class="bdr-rad2 shadow  p-1" 
            :chart-data="barChart.data"
            :chart-options="barChart.options"
            :chart-responsive-options="barChart.responsiveOptions"
            chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">Monthly Debtor Summary</h4>
        
            </template>
            <template slot="footer">
             
                <i class="fa fa-circle text-info"></i>Debtor
               
            
            
            </template>
          </chart-card>
        
        </div>

        <div class="col-md-4">

 
<chart-card class="bdr-rad2 shadow  p-1" v-if="isLoaded6" 
  :chart-data="pieChart.data"
  :chart-options="pieChart.options"
  :chart-responsive-options="pieChart.responsiveOptions"
  chart-type="Pie"
>
  <template slot="header">
    <h4 class="card-title">Debtors Summary by Salesman</h4>
    <p class="card-category"></p>
  </template>
  <template slot="footer">
    <div class="legend">
      <!-- <i class="fa fa-circle text-info"></i> Country -->
    </div>
  </template>
</chart-card>


</div>
<div class="col-md-4">
<chart-card class="bdr-rad2 shadow  p-1" v-if="isLoaded11" 
  :chart-data="pieChart4.data"
  :chart-options="pieChart4.options"
  :chart-responsive-options="pieChart4.responsiveOptions"
  chart-type="Pie"
>
  <template slot="header">
    <h4 class="card-title">Debtors Summary by Dealer</h4>
    <p class="card-category"></p>
  </template>
  <template slot="footer">
    <div class="legend">
      <!-- <i class="fa fa-circle text-info"></i> Country -->
    </div>
  </template>
</chart-card>


</div>
  

<!-- <div class="col-md-4">
          <chart-card v-if="isLoaded1"
            :chart-data="barChart2.data"
            :chart-options="barChart2.options"
            :chart-responsive-options="barChart2.responsiveOptions"
            chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">Cash Collection by Salesman</h4>
              <p class="card-category"></p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i>Debtor
               
              </div>
            
            </template>
          </chart-card>
        
        </div> -->

  


</div>
      

      <div class="row">


 
       
    



   

<div class="col-md-4">
          <div id="app">
    <DonutChartcon class="bdr-rad2 shadow  p-1" v-if="isLoaded3"
      :data="chartData"
      :colors="chartColors"
     
      :completionRate="valuecash"
    
    >
      <template v-slot:header>
        <h4 class="card-title">Cash Collected this month</h4>
      
      </template>
      <template v-slot:footer>
        <div class="legend">
          <i class="fa fa-circle text-info"></i> Cash
        </div>
      </template>
    </DonutChartcon>
  </div>
</div>

<div class="col-md-4">

 
<chart-card class="bdr-rad2 shadow  p-1" v-if="isLoaded1" 
  :chart-data="pieChart1.data"
  :chart-options="pieChart1.options"
  :chart-responsive-options="pieChart1.responsiveOptions"
  chart-type="Pie"
>
  <template slot="header">
    <h4 class="card-title">Cash Collection by Salesman</h4>
    <p class="card-category"></p>
  </template>
  <template slot="footer">
    <div style="margin-bottom: 18px;" class="legend">
      <!-- <i class="fa fa-circle text-info"></i> Country -->
    </div>
  </template>
</chart-card>


</div>

<div class="col-md-4">

 
<chart-card class="bdr-rad2 shadow  p-1" v-if="isLoaded10"
  :chart-data="pieChart3.data"
  :chart-options="pieChart3.options"
  :chart-responsive-options="pieChart3.responsiveOptions"
  chart-type="Pie"
>
  <template slot="header">
    <h4 class="card-title">Cash Collection by Dealer</h4>
    <p class="card-category"></p>
  </template>
  <template slot="footer">
    <div style="margin-bottom: 18px;" class="legend">
      <!-- <i class="fa fa-circle text-info"></i> Country -->
    </div>
  </template>
</chart-card>


</div>
       
        



  
      </div>

      <div class="row">
       
     


<div class="col-md-12">
          <!-- <chart-card style=" padding-bottom: 100px;" v-if="isLoaded8"
            :chart-data="lineChart3.data"
            :chart-options="lineChart3.options"
            :chart-responsive-options="lineChart3.responsiveOptions"
            chart-type="Line">
            <template slot="header">
              <h4 class="card-title">Month End Inventory</h4>
              <p class="card-category"></p>
            </template>
            <template slot="footer">
              <div class="legend">
            
               
              </div>
            
            </template>
          </chart-card> -->
  <AreaChart class="bdr-rad2 shadow  p-1" v-if="isLoaded8"
  :labels="labelsmonth"
  :data="labelsmonthvalue"
  :colors="['rgba(54, 162, 235, 0.4)', 'rgba(75, 192, 192, 0.4)']"
  :borderColors="['rgba(54, 162, 235, 1)', 'rgba(75, 192, 192, 1)']"
  :width="1200"
  :height="500"
>
  <template v-slot:header>
    <h4 class="card-title">Month End Inventory</h4>
  </template>
  <template v-slot:footer>
    <div class="legend">
      <i class="fa fa-circle text-info"></i> Inventory
   
    </div>
  </template>
</AreaChart>


        
        </div>




</div>




      <div class="row">
        <div class=" col-md-12">

         
            <br><br/>
         
        </div>
      </div>



    </div>
  </div>
</template>
<script>
import DonutChartcon from 'src/components/DonutChartcon.vue';
import AreaChart from 'src/components/AreaChart.vue';
import axios from 'axios';
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import Vue from "vue";
import fullCalendar from 'vue-fullcalendar'


Vue.component('full-calendar', fullCalendar)



  export default {
  watch: {
  },
  props: {
  },
    name: 'App',
    components: {
      LTable,
      ChartCard,
      StatsCard,
      DonutChartcon,
      AreaChart,
    },
    mounted(){
 
   //this.loadInventory();
    this.loadAlldata();
   
      },
    // created(){
    //   this.loadAlldata();
   
    //   },
    data () {
      return {

        isLoaded:false,
        isLoaded1:false,
        isLoaded3:false,
        isLoaded4:false,
        isLoaded5:false,
        isLoaded6:false,
        isLoaded7:false,
        isLoaded8:false,
        isLoaded9:false,
        isLoaded10:false,
        isLoaded11:false,
        all_data :{},
        ddata_set:[],
        labelsmonthvalue:[],
        labelsmonth:[],
        dealer_names_last:[],
        dealer_names1_this:[],
        cash:[],
        chartData: [], // Example data, not used directly in the drawChart method
        chartData1: [], // Example data, not used directly in the drawChart method
      chartColors: [ '#36a2eb','rgb(242, 243, 244)'], 
      valuecash:'',// Primary color for completion
      valuequtation:'',// Primary color for completion
   
        pieChart: {
          data: {
            labels: ['70', ' 50'],
            // series: [{value:70, className:'my1color'},{value:50,className:'my2color' }],
            series: [70,50],
            
      }

      



        },
        pieChart3: {
          data: {
            labels: ['70', ' 50'],
            // series: [{value:70, className:'my1color'},{value:50,className:'my2color' }],
            series: [70,50],
              
          
            
          }
        },
        pieChart1: {
          data: {
            labels: ['103','10','4'],
            series: [103, 10,4],
           
          }
        },
        pieChart4: {
          data: {
            labels: ['103','10','4'],
            series: [103, 10,4],
           
          }
        },

        doughnutChart: {
          data: {
            labels: ['70', '50'],
            series: [
              { value: 70, className: 'my1color' },
              { value: 50, className: 'my2color' }
            ]
          },
          options: {
            donut: true,
            donutWidth: 40, // Adjust this value to control the width of the donut
            startAngle: 0,
            total: 100,
            showLabel: true
          }
        },


        lineChart: {
         
            data: {
              labels:[],
              series:[]
            
          },
       

          options: {
           
            low: 0,
            high: 2000000,
            showArea: false,
            height: '245px',
        axisX: {
            showGrid: false,
            showLabel: true,  // Ensure x-axis labels are shown
            offset: 50,
            
            labelOffset: {
              x: 0,
              y: 5, // Adjust the y-offset if needed
            },
          },
          axisY: {
            showGrid: true,
            showLabel: true,
            offset: 30,
            labelInterpolationFnc: (value, index) => {
     
              if(index ==0 || index ==4 || index ==8){
                if (value >= 1000000) {
                return (value / 1000000).toFixed(1) + 'M'; // Format values in millions
              } else if (value >= 1000) {
                return (value / 1000).toFixed(1) + 'k'; // Format values in thousands
              }
              return value;
              }else{
                return '';
              }
             
          },
            
            // Ensure y-axis labels are shown
          },
            lineSmooth: true,
            showLine: true,
            showPoint: true,
            fullWidth: true,
            chartPadding: {
              right: 30,
              left:30
            }
          },
        
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        lineChart1: {
         
            data: {
              labels:[],
              series:[]
            
          },
       

          options: {
           
            low: 0,
            high: 2000000,
            showArea: false,
            height: '245px',
            axisX: {
            showGrid: false,
            showLabel: true,  // Ensure x-axis labels are shown
            offset: 50,
            
            labelOffset: {
              x: 0,
              y: 5, // Adjust the y-offset if needed
            },
          },
          axisY: {
            showGrid: true,
            showLabel: true,
            offset: 30,
            labelInterpolationFnc: (value, index) => {
     
              if(index ==0 || index ==4 || index ==8){
                if (value >= 1000000) {
                return (value / 1000000).toFixed(1) + 'M'; // Format values in millions
              } else if (value >= 1000) {
                return (value / 1000).toFixed(1) + 'k'; // Format values in thousands
              }
              return value;
              }else{
                return '';
              }
             
          },
            
            // Ensure y-axis labels are shown
          },
            lineSmooth: true,
            showLine: true,
            showPoint: true,
            fullWidth: true,
            chartPadding: {
              right: 30,
              left:30
            }
          },
        
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },

        

        barChart1: {
        data: {
          labels: [ 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          series: [[ 200, 295, 352, 410, 572, 734]],
        },
        options: {
          axisX: {
            showGrid: true,
          },
          axisY: {
            onlyInteger: true,
            offset: 40,
          },
          low: 0,
          high: 1000,
          axisX: {
            showGrid: true,
            showLabel: true,  // Ensure x-axis labels are shown
            },
            axisY: {
            showGrid: false,
            showLabel: true,  // Ensure y-axis labels are shown
            },
            chartPadding: {
              right: 40
            },
          horizontalBars: true,
          reverseData: true,
          seriesBarDistance: 1,
          height: '250px', // Adjust the height of the chart as needed
        },
        responsiveOptions: [
          ['screen and (max-width: 640px)', {
            seriesBarDistance: 5,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value[0];
              },
            },
          }],
        ],
      },
        barChart2: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          axisX: {
            showGrid: true,
          },
          axisY: {
            onlyInteger: true,
            offset: 40,
          },
          low: 0,
          high: 29428293,
          axisX: {
            showGrid: true,
            showLabel: true,  // Ensure x-axis labels are shown
            },
            axisY: {
            showGrid: false,
            showLabel: true,  // Ensure y-axis labels are shown
            },
            chartPadding: {
              right: 40
            },
          horizontalBars: true,
          reverseData: true,
          seriesBarDistance: 1,
          height: '250px', // Adjust the height of the chart as needed
        },
        responsiveOptions: [
          ['screen and (max-width: 640px)', {
            seriesBarDistance: 5,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value[0];
              },
            },
          }],
        ],
      },


      barChart3: {
        data: {
          labels: [],
          series: [],
        },
        options: {
        
          axisY: {
            onlyInteger: true,
            offset: 90,
            showGrid: false,
            showLabel: true, 
          
          },
          low: 0,
          high: 20000000,
          axisX: {
            showGrid: true,
            showLabel: true,
            offset: 50,
            
            labelOffset: {
              x: 0,
              y: 10, // Adjust the y-offset if needed
            },
            labelInterpolationFnc: (value, index) => {
      // Calculate interval to show 5 labels
              if(index ==0 || index ==4 || index ==8){
                if (value >= 1000000) {
                return (value / 1000000).toFixed(1) + 'M'; // Format values in millions
              } else if (value >= 1000) {
                return (value / 1000).toFixed(1) + 'k'; // Format values in thousands
              }
              return value;
              }else{
                return '';
              }
             
          },
          },

     

           
            chartPadding: {
              right: 40
            },
          horizontalBars: true,
          reverseData: true,
          seriesBarDistance: 1,
          height: '280px', // Adjust the height of the chart as needed
        },
        responsiveOptions: [
          ['screen and (max-width: 640px)', {
            seriesBarDistance: 5,
           
          }],
        ],
      },


      barChart4: {
        data: {
          labels: [],
          series: [],
        },
        options: {
        
          axisY: {
            onlyInteger: true,
            offset: 70,
            showGrid: false,
            showLabel: true, 
          
          },
          low: 0,
          high: 9000000,
          axisX: {
            showGrid: true,
            showLabel: true,
            offset: 40,
            
            labelOffset: {
              x: 0,
              y: 10, // Adjust the y-offset if needed
            },
            labelInterpolationFnc: (value, index) => {
      // Calculate interval to show 5 labels
              if(index ==0 || index ==4 || index ==8){
                if (value >= 1000000) {
                return (value / 1000000).toFixed(1) + 'M'; // Format values in millions
              } else if (value >= 1000) {
                return (value / 1000).toFixed(1) + 'k'; // Format values in thousands
              }
              return value;
              }else{
                return '';
              }
             
          },
          },

     

           
            chartPadding: {
              right: 40
            },
          horizontalBars: true,
          reverseData: true,
          seriesBarDistance: 1,
          height: '280px', // Adjust the height of the chart as needed
        },
        responsiveOptions: [
          ['screen and (max-width: 640px)', {
            seriesBarDistance: 5,
           
          }],
        ],
      },

      lineChart3: {
          data: {
            labels: [],
            series: []
          },
          options: {
            
            seriesBarDistance: 1,
            low: 0,
            
            height: '400px', 
            axisY: {
            onlyInteger: true,
            offset: 50,
            showGrid: true,
            showLabel: true, 
            labelInterpolationFnc: (value, index) => {
      // Calculate interval to show 5 labels
              if(index ==0 || index ==3 || index ==6){
                if (value >= 1000000) {
                return (value / 1000000).toFixed(1) + 'M'; // Format values in millions
              } else if (value >= 1000) {
                return (value / 1000).toFixed(1) + 'k'; // Format values in thousands
              }
              return value;
              }else{
                return '';
              }
             
          },
          
          },
          low: 0,
          high: 60000000,
          chartPadding: {
             // right: 40
            },
          axisX: {
            showGrid: false,
            showLabel: true,
            offset: 150,
            
            labelOffset: {
              x: 0,
              y: 10, // Adjust the y-offset if needed
            },
           
          },
          
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ],

   
  
        },


        barChart: {
          data: {
            labels: ['Jan', 'Feb', 'Mar', 'Apri', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            series: [
            [2475486.71, 2475486.71, 2475486.71, 2475486.71, 2475486.71, 2475486.71, 2475486.71, 0, 0, 0, 0, 0],
              //[412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]
            ]
          },
          options: {
            seriesBarDistance: 1,
            high: 3000000.71,
            axisY: {
            onlyInteger: true,
            offset: 35,
            showGrid: false,
            showLabel: true, 
            labelInterpolationFnc: (value, index) => {
      // Calculate interval to show 5 labels
              if(index ==0 || index ==4 || index ==8){
                if (value >= 1000000) {
                return (value / 1000000).toFixed(1) + 'M'; // Format values in millions
              } else if (value >= 1000) {
                return (value / 1000).toFixed(1) + 'k'; // Format values in thousands
              }
              return value;
              }else{
                return '';
              }
             
          },
          },
          },
          low: 0,
          high: 9000000,
          axisX: {
            showGrid: true,
            showLabel: true,
            offset: 10,
            
            labelOffset: {
              x: 0,
              y: 50, // Adjust the y-offset if needed
            },
          
          
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ],
          fcEvents: [
  {
    title: 'Perfect Day for Rain',
    start: '2016-05-15',
    end: '2016-05-20',
    
  },
  {
    title: 'Wait another month for VueConf',
    start: '2017-05-21',
    end: '2017-05-22',
    cssClass: 'vueconf'
  },
  {
    title: 'A single sunny day',
    start: '2017-05-29',
    end: '2017-05-29'
  }
]
        },
        tableData: {
          data: [
            {title: 'Sign contract for "What are conference organizers afraid of?"', checked: false},
            {title: 'Lines From Great Russian Literature? Or E-mails From My Boss?', checked: true},
            {
              title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
              checked: true
            },
            {title: 'Create 4 Invisible User Experiences you Never Knew About', checked: false},
            {title: 'Read "Following makes Medium better"', checked: false},
            {title: 'Unfollow 5 enemies from twitter', checked: false}
          ]
        }
      }
    },

    methods:{ 


      

      updateLabels(newLabels) {
      this.lineChart.data.labels = newLabels;
    },
      updateSeries(newSeries) {
      //  this.$set(this.lineChart.data, 'series',newSeries);
        this.lineChart.data.series = newSeries;
      console.log("Amia");
    },
      updateweekLabels(newLabels) {
      this.lineChart1.data.labels = newLabels;
    },
      updateweekkSeries(newSeries) {
      //  this.$set(this.lineChart.data, 'series',newSeries);
        this.lineChart1.data.series = newSeries;
      console.log("Amia");
    },
    updateinventoryLabels(newLabels) {
      this.labelsmonth = newLabels;
    },
      updateinventorySeries(newSeries) {
      //  this.$set(this.lineChart.data, 'series',newSeries);
        this.labelsmonthvalue = newSeries;
      console.log("Amia");
    },
    updateDbseries(newSeries) {
      //  this.$set(this.lineChart.data, 'series',newSeries);
        this.lineChart.data.series = newSeries;
      console.log("Amia");
    },
    updateCashname(newSeries) {
      console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
        this.barChart2.data.labels = newSeries;
      
    
    },
    updateCashvalue(newSeries) {
      console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
        this.barChart2.data.series = newSeries;
      
    
    },
    updateCashname1(newSeries) {
      console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
       
        this.pieChart1.data.labels = newSeries;
    
    },
    updateCashvalue1(newSeries) {
      console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
      
        this.pieChart1.data.series = newSeries;
    
    },
    updateDebotername5(newSeries) {
      console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
       
        this.pieChart4.data.labels = newSeries;
    
    },
    updateDebotervalue5(newSeries) {
      console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
      
        this.pieChart4.data.series = newSeries;
    
    },
    updateDebdealername(newSeries) {
      console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
       
        this.pieChart3.data.labels = newSeries;
    
    },
    updateDebdealervalue(newSeries) {
      console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
      
        this.pieChart3.data.series = newSeries;
    
    },
    updateSalesname(newSeries) {
      console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
        this.barChart3.data.labels = newSeries;
    
    },
    updateSalesvalue(newSeries) {
      console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
        this.barChart3.data.series = newSeries;
    
    },

    updateDealername(newSeries) {
      // console.log('amila1');
      // console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
         this.barChart4.data.labels =  newSeries;
    
    },
    updateDealervalue(newSeries) {
      // console.log('amila2');
      // console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
         this.barChart4.data.series = newSeries;
    },
    updateDebtorname(newSeries) {
      // console.log('amila1');
      // console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
         this.pieChart.data.labels =  newSeries;
    
    },
    updateDebtorvalue(newSeries) {
      // console.log('amila2');
      // console.log(newSeries);
      //  this.$set(this.lineChart.data, 'series',newSeries);
         this.pieChart.data.series = newSeries;
    
    },


    async loadDebtordealer() {
        
       
        const { data} = await  axios.get('/mcustomer/dealerdebotor',{

         
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
            const deler_name6 = data.deler_name6;
           
        //    console.log(sales_person);
       
          this.updateDebotername5(deler_name6); 

           const dealer_value6 = data.dealer_value6;
           
        
       
         this.updateDebotervalue5(dealer_value6); 
         this.isLoaded11=true;
         this.loadMiinventory();
    //  this.isLoaded=true;
      
    //      this.updateLabels(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
    //    const staticData = data.all_data.data_set;
  
     
    },


    async loadCashdealer() {
        
       
        const { data} = await  axios.get('/mcustomer/cashdealer',{

         
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
            const dealer_name5 = data.dealer_name5;
           
        //    console.log(sales_person);
        //  this.updateCashname(sales_person); 
          this.updateDebdealername(dealer_name5); 

           const dealer_value5 = data.dealer_value5;
           
           console.log(dealer_value5);
       //  this.updateCashvalue([cash_value]); 
         this.updateDebdealervalue(dealer_value5); 
         this.isLoaded10=true;
         this.loadDebtordealer();
    //  this.isLoaded=true;
      
    //      this.updateLabels(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
    //    const staticData = data.all_data.data_set;
  
     
    },



    async loadQuotation() {
        
       
        const { data} = await  axios.get('/mcustomer/cashquotation',{

         
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.valuequtation = data.valuequtation;
         this.chartData1 =  data.datedonnut;

         console.log(this.chartData1);
         this.isLoaded9=true;
         this.loadCashdealer();
   
     
    },
    


    async loadDebtorsummary() {
        
       
        const { data} = await  axios.get('/mcustomer/debtorsummary',{

         
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
            const sales_person2 = data.sales_person2;
           
        //    console.log(sales_person);
          this.updateDebtorname(sales_person2); 

           const debotor_value2 = data.debotor_value2;
           
        
         this.updateDebtorvalue(debotor_value2); 
         this.isLoaded6=true;
      //   this.loadCashcollection();
    //  this.isLoaded=true;
      
    //      this.updateLabels(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
    //    const staticData = data.all_data.data_set;
    this.loadQuotation();
     
    },
    


   


    async loadSalesdealer() {
        
       
        const { data} = await  axios.get('/mcustomer/salesdealer',{

         
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
            const dealer1 = data.dealer1;
           
        //    console.log(sales_person);
          this.updateDealername(dealer1); 

           const dealer_value1 = data.dealer_value1;
           
           console.log(dealer_value1);
         this.updateDealervalue([dealer_value1]); 
         this.isLoaded5=true;
      //   this.loadCashcollection();
    //  this.isLoaded=true;
      
    //      this.updateLabels(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
    //    const staticData = data.all_data.data_set;
    this.loadDebtorsummary();
     
    },
    async loadSalessalesman() {
        
       
        const { data} = await  axios.get('/mcustomer/salessalesman',{

         
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
            const sales_person1 = data.sales_person1;
           
        //    console.log(sales_person);
          this.updateSalesname(sales_person1); 

           const sales_value1 = data.sales_value1;
           
           console.log(sales_value1);
         this.updateSalesvalue([sales_value1]); 
         this.isLoaded4=true;
      //   this.loadCashcollection();
    //  this.isLoaded=true;
      
    //      this.updateLabels(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
    //    const staticData = data.all_data.data_set;
    this.loadSalesdealer();
     
    },


    async loadCashcollection() {
        
       
        const { data} = await  axios.get('/mcustomer/cashcollection',{

         
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.valuecash = data.valuecash;
         this.chartData =  data.datedonnut;

         console.log(this.chartData);
         this.isLoaded3=true;
         this.loadSalessalesman();
        //     const sales_person = data.sales_person;
           
        // //    console.log(sales_person);
        //   this.updateCashname(sales_person); 

        //    const cash_value = data.cash_value;
           
        //    console.log(cash_value);
        //  this.updateCashvalue([cash_value]); 
        //  this.isLoaded1=true;
        
    //  this.isLoaded=true;
      
    //      this.updateLabels(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
    //    const staticData = data.all_data.data_set;
  
     
    },


    async loadDebotor() {
        
       
          const { data} = await  axios.get('/mcustomer/dashborddebotor',{
  
           
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);
            this.ddata_set = data.ddata_set;
            const debotor = data.ddata_set;
            console.log(debotor);
         this.updateDbseries([debotor]); 
      
        
      //      this.updateLabels(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
      //    const staticData = data.all_data.data_set;
    
       
      },

      async loadCashsalesman() {
        
       
        const { data} = await  axios.get('/mcustomer/cashsalesman',{

         
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
            const sales_person = data.sales_person;
           
        //    console.log(sales_person);
          this.updateCashname(sales_person); 
          this.updateCashname1(sales_person); 

           const cash_value = data.cash_value;
           
           console.log(cash_value);
         this.updateCashvalue([cash_value]); 
         this.updateCashvalue1(cash_value); 
         this.isLoaded1=true;
         this.loadCashcollection();
    //  this.isLoaded=true;
      
    //      this.updateLabels(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
    //    const staticData = data.all_data.data_set;
  
     
    },

      async loadMiinventory() {
        
       
       
       try {
       
         const { data} = await  axios.get('/mcustomer/dashbord',{
 
          
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          // this.all_data = data.all_data;
        
       
          this.updateLabels(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);
        const staticData = data.all_data.data_set;
      
        console.log(staticData);
        this.updateSeries([staticData]); 
      this.isLoaded=true;
     this.loadweeksummery();
         
        
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async loadInventory() {
        
       
       
        try {
        
          const { data} = await  axios.get('/mcustomer/inventory',{
  
           
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);
           // this.all_data = data.all_data;
         
        
          

        const staticDatainvlabel = data.all_data.inventorylabel;
        console.log(staticDatainvlabel);
        this.updateinventoryLabels(staticDatainvlabel);


         const staticDatainv = data.all_data.inventory;
         this.updateinventorySeries([staticDatainv]); 
          this.isLoaded8=true;
      
          
         
          
        } catch (error) {
          console.log(error.response);
        }
      },


     async loadweeksummery() {
        
       
       
        try {
        
          const { data} = await  axios.get('/mcustomer/weeklysummery',{
  
           
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);
           // this.all_data = data.all_data;
         
        
           this.updateweekLabels(['Jan', 'Feb', 'Mar', 'Apr', 'May','jun', ]);

        const staticDataweeklabel = data.all_data.weeklylabel;
        console.log(staticDataweeklabel);
        this.updateweekLabels(staticDataweeklabel);


         const staticDataweek = data.all_data.weekly;
         this.updateweekkSeries([staticDataweek]); 
          this.isLoaded7=true;

          this.loadInventory();
      
          
         
          
        } catch (error) {
          console.log(error.response);
        }
      },

     async loadAlldata() {
        
       
       
        try {
        
          const { data} = await  axios.get('/mcustomer/dashbordalldata',{
  
           
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
             
            }
           });
           console.log(data);
           this.all_data = data.all_data;
           this.dealer_names1_this = data.all_data.dealer_names1_this
           this.dealer_names_last = data.all_data.dealer_names_last
           ;
           
           this.loadCashsalesman();
        
          
        } catch (error) {
          console.log(error.response);
        }
      },
    }



  }
</script>
<style >

#app {
  text-align: center;
 
}

.card-title {
  margin-bottom: 10px;
}

.legend {
  margin-top: 10px;
}

.fa-circle.text-info {
  color: #36a2eb;
}
.btn {
  opacity: 1 !important;
}
.custom-btn {
  color: white; 
  border: 0px;
}

.comp-full-calendar {
  padding: 20px; 
    background: #fff;
    max-width: 100% !important;
    margin: 0 auto;
}
.my1color{
  fill: pink !important;
  color: pink !important;
  

  
}
.my2color{
  fill: yellow !important;
  color: yellow !important;

  
 

}

.bg-color{
  background-color: rgb(242, 243, 244);
}

.ct-label.ct-horizontal {
  transform: rotate(-45deg);
  transform-origin: 75% 50%;
  text-anchor: end;
}

.ct-label {
  font-size: 5px !important; /* Adjust the font size to make it smaller */
  fill: #000; /* Ensure the text is a visible color */
}
.card .ct-label {
    font-size: 0.7rem !important;
}

.ct-chart-pie .ct-slice-pie {
  stroke-width: 50px; /* Adjust the stroke width if necessary */
}

.ct-legend {
  font-size: 12px; /* Adjust the font size of the legend */
  color: #000; /* Ensure the legend is visible */
}

</style>
